import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BusinessService",
  controller: "BusinessOutPayment",
};
const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "GetItemById",
  "SubMerAccOutPayment",
  "SendMobileMessageForSubMer",
  "FindByConditions",
  "GetPageContentByConditions",
  "FindByConditionsToExcel",
  "GetPaySum"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    Fun.prototype[path] = function (data) {
      return this.post(path, data);
    };
  });
};

const BusinessOutPaymentApi = ZJApi.defineNewApi("BusinessOutPaymentApi", factory);

export default BusinessOutPaymentApi;